module.exports = __webpack_public_path__ + "media/images/icons/candles-42a58c35f49fed5e750fea96a29a50f5.svg";